import React from 'react';

const ProductItem = ({item}) => {

	const productDetail = ( 
		<ul className="product-details">

			<p className="product-title"> {item.title} </p>
			{ item.price > 0 ? (<li>R {item.price}</li>) : ""}
			<li>{item.size}</li>
			{ item.length > 0 ? (<li>Length: {item.length} cm</li> ): ""}
		
		</ul>
	)


	return (
			<div className="product-item">
				<div className="product-item-container">
					
					<div className="item-pic-container">

						<a href={`https://instagram.com/p/${item.src}`} target="_blank" rel="noopener noreferrer">
							<img className="item-pic" src={`http://thriftsavannaproxy.herokuapp.com/instagram?src=${item.src}`} alt="clothing item"/>
						</a>
					</div>

					<div className="Caption">	
						{productDetail}
						<a
							className="row-container comment-and-claim"
							rel="noopener noreferrer" 
							target="_blank"
							//href={item.instalink}
							href={`https://instagram.com/p/${item.src}`}
						>
							<i className="instagram icon link"></i> 
							<p className="instagram-link"> Comment and Claim </p> 
						</a> 
					</div>
				</div>
			</div>
	)
}

export default ProductItem;